import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanComponent } from './boolean/boolean.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DateComponent } from './date/date.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { InputComponent } from './input/input.component';
import { PriceComponent } from './price/price.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { SelectComponent } from './select/select.component';
import { TextAreaComponent } from './text-area/text-area.component';

import { ListModule } from '../list/list.module';
import { PageHeaderModule } from '../page-header/page-header.module';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';;
import { FileUploadModule } from 'ng2-file-upload';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DynamicFieldDirective } from './dynamicFieldDirective/dynamic-field.directive';
import { ScrollbarModule } from '../scrollbar/scrollbar.module';
import { DirectiveModule } from '../directive/directive.module';
import { SharedModule } from '../shared.module';
import { FileUploadGComponent } from './file-upload-g/file-upload-g.component';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { FileUploadPdfComponent } from './file-upload-pdf/file-upload-pdf.component';
import { TextEditorModule } from '../text-editor/text-editor.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SimpleDynamicComponentModule } from '../simple-form/simple-dynamic-component.module';
import { MultipleImagesComponent } from './multiple-images/multiple-images.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { CommonImagesModule } from 'src/app/pages/common-images/common-images.module';
import { PhoneNoComponent } from './phone-no/phone-no.component';



@NgModule({
    declarations: [BooleanComponent,
        CheckboxComponent, DateComponent,
        SelectComponent,
        TextAreaComponent,
        FileUploadComponent, InputComponent,
        DynamicFieldDirective,
        PriceComponent, RadioButtonComponent, MultiSelectComponent, FileUploadGComponent,FileUploadPdfComponent,
        MultipleImagesComponent, AutocompleteComponent, PhoneNoComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ListModule,
        PageHeaderModule,
        BreadcrumbsModule,
        CustomFlexLayoutModule,
        FileUploadModule,
        NgxMatSelectSearchModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatListModule,
        MatProgressBarModule,
        MatRadioModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatNativeDateModule,
        DirectiveModule,
          MatSidenavModule,
        ScrollbarModule,
        SharedModule,
        CommonFileUploadModule,
        TextEditorModule,
        SimpleDynamicComponentModule,
        MatAutocompleteModule,
        MatChipsModule,
        CommonImagesModule,
    ],
    exports: [
        FileUploadComponent,
        DynamicFieldDirective,
    ]
})
export class DynamicFormModule { }
